import { Calendar } from 'framework/calendar';
import { CALENDAR_MODE } from 'framework/calendar/enums';
import { CalendarProps } from 'framework/calendar/types';
import { OptionMenu } from 'framework/Option';

import { EMPTY_ARRAY, EMPTY_FUNCTION } from '../../constants';
import { OptionsMenuProps, OptionsProps } from '../Options/types';

import { Options as OptionsComponent } from './fields/Options';
import { OptionsCalendar as OptionsCalendarComponent } from './fields/OptionsCalendar';

export const Options = ({ height = 210, children }: OptionsProps) => {
  return <OptionsComponent height={height}>{children}</OptionsComponent>;
};

export const OptionsMenu = ({
  label = '',
  icon,
  onSelect = EMPTY_FUNCTION,
  height = 210,
}: Omit<OptionsMenuProps, 'children'>) => {
  return (
    <OptionsComponent height={height}>
      <OptionMenu label={label} icon={icon} onSelect={onSelect} />
    </OptionsComponent>
  );
};

export const OptionsCalendar = ({
  mode = CALENDAR_MODE.SINGLE,
  format = 'MM/DD/YYYY',
  value = EMPTY_ARRAY,
  min_date,
  max_date,
  onSelect = EMPTY_FUNCTION,
}: CalendarProps) => {
  return (
    <OptionsCalendarComponent>
      <Calendar
        value={value}
        mode={mode}
        min_date={min_date}
        max_date={max_date}
        format={format}
        onSelect={onSelect}
      />
    </OptionsCalendarComponent>
  );
};
